<template>
  <div class="conteudoInterno" id="arrecadacao">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Arrecadação</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcGreenBack"></span>
        </div>
        <div class="col66 spaceBetween top32">
          <div class="col49sub">
            <p>
              Os números nesta página são uma visão geral das arrecadações de
              direitos de execução pública no Brasil, realizadas pelo Ecad,
              entidade responsável pelo licenciamento desses direitos em nome
              das sete associações brasileiras de execução pública, entre elas a
              UBC. Com isso, buscamos apresentar um panorama completo do mercado
              brasileiro.
            </p>
            <p>
              O sistema vigente concede licenças relacionadas tanto aos direitos
              autorais como conexos da maioria (mas não de todos) os usuários.
              Exceções à licença de direitos conexos incluem shows ao vivo (já
              que não há gravações em que basear as distribuições) e muitos
              serviços de transmissão digital (tanto de música quanto de vídeo
              sob demanda), nos quais as licenças são gerenciadas diretamente
              pelas gravadoras em nível global. A UBC tem colaborado com o Ecad
              em um esforço para incluir mais serviços sob o escopo da licença
              de direitos conexos.
            </p>
          </div>
          <div class="col49sub">
            <p>
              Vale destacar também que os números não incluem os direitos
              fonomecânicos, pois estes não são arrecadados por meio de uma
              estrutura centralizada de gestão coletiva no Brasil.
            </p>
            <p>
              A parte final do relatório traz informações específicas da UBC,
              incluindo dados sobre os direitos fonomecânicos que são
              administrados por nós, embora esses números reflitam apenas um
              panorama parcial do mercado total brasileiro.
            </p>
          </div>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            <span class="ubcGreen sanukBlack">R$ 2,105 bilhões </span>foi o
            total arrecadado pelo Ecad em 2025, um
            <span class="ubcGreen sanukBlack">crescimento de 15%</span> em
            relação ao ano anterior.
          </h4>
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h3>Participação na arrecadação por tipo de uso</h3>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <PieChart1 v-if="isView" />
            </div>
          </div>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h3>Crescimento por tipo de uso</h3>
          <span
            style="
              font-size: 12px;
              margin-top: 40px;
              margin-bottom: -30px;
              display: block;
            "
            >BRL</span
          >
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <LineChart1A />
            </div>
          </div>
        </div>
      </section>
      <!-- <section class="sectionRow top120">
        <div class="col49">
          <h3>Participação na arrecadação por tipo de uso</h3>
          <div class="top20">
            <PieChart1 />
          </div>
        </div>
        <div class="col49">
          <h3>Crescimento por tipo de uso</h3>
          <div class="graphContainer">
            <div class="graph">

            <LineChart1A />
            </div>
          </div>
        </div>
      </section> -->
      <section class="sectionRow top80">
        <div class="col40ponto4 ubcGreenBack">
          <!-- imagem -->
        </div>
        <div class="col49 spaceBetween">
          <div class="col100">
            <h4 class="h4Destaque ubcGreen sanukBlack">Destaques</h4>
          </div>
          <div class="col100 spaceBetween top50">
            <div class="col49sub">
              <div class="blockBigNumbers">
                <div>
                  <h6>Crescimento de</h6>
                  <h5 class="ubcGreen sanukBlack">47,2%</h5>
                  <h6>em <span class="sanukBold">Digital</span></h6>
                </div>
                <p>
                  Outro ano em que o segmento digital se expandiu com muito
                  força, consolidando-se como uma importante fonte de receitas
                  para a gestão coletiva, graças ao contínuo crescimento da base
                  de assinante das plataformas e da oferta de VOD.
                </p>
              </div>
              <div class="blockBigNumbers">
                <div>
                  <h6>Crescimento de</h6>
                  <h5 class="ubcGreen sanukBlack">13,2%</h5>
                  <h6>em <span class="sanukBold">Shows</span></h6>
                </div>
                <p>
                  Os grandes festivais e as grandes turnês de artistas nacionais
                  e internacionais pelo país contribuíram outro ano mais para a
                  expansão desse segmento, um dos mais afetados pelos anos de
                  paralisação na pandemia e já plenamente recuperado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";
import PieChart1 from "./Grafico1.vue";
import LineChart1A from "./Grafico2.vue";
import SwipperMobile from "./SwipperMobile.vue";

export default {
  name: "ArrecadacaoPage",
  props: ["clicked"],
  components: {
    PieChart1,
    LineChart1A,
    SwipperMobile,
  },
  data() {
    return {
      setaScrollState: false,
      isView: false,
    };
  },
  destroyed() {
    this.myStopFunction();
  },
  mounted() {
    this.showSetaScroll();

    const conteudo = document.querySelector("#arrecadacao");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);

    setTimeout(() => {
      this.isView = true;
    }, 1500);
  },
  methods: {
    showSetaScroll: function () {
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if (alturaTela - 50 <= alturaDiv && boxABB.top == 148) {
          this.setaScrollState = true;
        } else {
          this.setaScrollState = false;
        }
      }, 1000);
    },
    myStopFunction: function () {
      clearInterval(this.refresh);
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blockBigNumbers {
  margin: 0 0 45px 0;
}
.blockBigNumbers div {
  margin: 0 0 8px 0;
}
.canvasGraphicArea {
  width: 100%;
  background: #cecece;
}

.graphContainer {
  padding-top: 20px;
  width: 100%;
  /* background-color: #168ECD; */
  overflow-x: scroll;
}

.graphContainer::-webkit-scrollbar {
  background-color: white;
  border-radius: 10px;
  width: 20px;
}

.graphContainer::-webkit-scrollbar-thumb {
  background-color: #8bc53f;
  border-radius: 10px;
  border: 5px solid white;
}

.graph {
  min-width: 500px;
  min-height: 250px;
}
</style>
